
import { parseCurrency } from 'vue-currency-input';
import numeral from 'numeral'


export default {
    methods: {
        parseFromBackend(value) {
            return value / 100;
        },
        parseToBackend(value) {
            return parseCurrency(value, {
                local: 'en',
                currency: 'USD'
            }) * 100;
        },
        getNumberFormatted(v) {
            return numeral(v).format('0,0.00');
        },
    }
}